import React, { useEffect, useState } from 'react'
import PageHeader from '../../components/Custom/PageHeader/PageHeader'
import axiosInterceptorInstance from '../../utils/axios/axiosInterceptorInstance'

const Limit = () => {
  const [limits, setLimits] = useState([])
  const [form, setForm] = useState({ userType: '', limit: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [editId, setEditId] = useState(null)

  // Fetch limits
  const fetchLimits = async () => {
    setLoading(true)
    setError('')
    try {
      const res = await axiosInterceptorInstance.get('/ratelimit')
      console.log('res', res)
      setLimits(res.data)
    } catch (err) {
      setError('Failed to fetch limits')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchLimits()
  }, [])

  // Handle form input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  // Handle form submit (add or update)
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      if (editId) {
        // Update
        await axiosInterceptorInstance.put(`/ratelimit/${editId}`, {
          limit: form.limit,
        })
      } else {
        // Add
        await axiosInterceptorInstance.post('/ratelimit', form)
      }
      setForm({ userType: '', limit: '' })
      setEditId(null)
      fetchLimits()
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save limit')
    }
    setLoading(false)
  }

  // Handle edit button
  const handleEdit = (item) => {
    setEditId(item._id)
    setForm({ userType: item.userType, limit: item.limit })
  }

  // Handle cancel edit
  const handleCancel = () => {
    setEditId(null)
    setForm({ userType: '', limit: '' })
  }

  return (
    <div>
      <PageHeader>
        <div className='flex gap-2 items-center justify-between w-full'>
          <div className='flex gap-2 items-center font-medium'>
            <h1 className='text-2xl'>Limit</h1>
          </div>
        </div>
      </PageHeader>

      <div className='p-4'>
        <form onSubmit={handleSubmit} className='mb-4 flex gap-2'>
          <input
            type='text'
            name='userType'
            placeholder='User Type'
            value={form.userType}
            onChange={handleChange}
            className='border px-2 py-1'
            required
            disabled={!!editId} // Prevent changing userType on edit
          />
          <input
            type='text'
            name='limit'
            placeholder='Limit'
            value={form.limit}
            onChange={handleChange}
            className='border px-2 py-1'
            required
          />
          <button
            type='submit'
            className={`bg-[#EF4044] text-white px-4 py-1 rounded`}
            disabled={loading}
          >
            {editId ? 'Update Limit' : 'Add Limit'}
          </button>
          {editId && (
            <button
              type='button'
              className='bg-gray-400 text-white px-4 py-1 rounded'
              onClick={handleCancel}
            >
              Cancel
            </button>
          )}
        </form>
        {error && <div className='text-[#EF4044] mb-2'>{error}</div>}
        <div>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <table className='min-w-full border'>
              <thead>
                <tr>
                  <th className='border px-2 py-1'>User Type</th>
                  <th className='border px-2 py-1'>Limit</th>
                  <th className='border px-2 py-1'>Actions</th>
                </tr>
              </thead>
              <tbody>
                {limits.map((item) => (
                  <tr key={item._id}>
                    <td className='border px-2 py-1'>{item.userType}</td>
                    <td className='border px-2 py-1'>{item.limit}</td>
                    <td className='border px-2 py-1'>
                      <button
                        className='bg-[#EF4044] text-white px-2 py-1 rounded'
                        onClick={() => handleEdit(item)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )
}

export default Limit
